import storefront from '@/api/storefront';

/**
 * First-party storefront events (D22) for the platform's funnel and channel
 * analytics. No cookies and no third-party trackers: a random session id lives in
 * sessionStorage (the server stores only its HMAC), and the attribution (UTM tags,
 * ad click id, referring host) is captured once when the session starts.
 * Fire-and-forget; respects Do Not Track; never throws into a page.
 */
const SESSION = 'mp_sf_session';
const ATTRIBUTION = 'mp_sf_attribution';
let memory = null; // when sessionStorage is unavailable

function store() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function randomId() {
  const bytes = new Uint8Array(18);
  window.crypto.getRandomValues(bytes);
  return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function session() {
  const s = store();
  const existing = s ? s.getItem(SESSION) : memory && memory.session;
  if (existing) return existing;
  const id = randomId();
  if (s) s.setItem(SESSION, id);
  else memory = { ...(memory || {}), session: id };
  return id;
}

function attribution() {
  const s = store();
  const saved = s ? s.getItem(ATTRIBUTION) : memory && memory.attribution;
  if (saved) return typeof saved === 'string' ? JSON.parse(saved) : saved;
  const q = new URLSearchParams(window.location.search);
  let referrer = null;
  try {
    const host = document.referrer ? new URL(document.referrer).host : null;
    referrer = host && host !== window.location.host ? host : null;
  } catch {
    referrer = null;
  }
  const a = { utm_source: q.get('utm_source'), utm_medium: q.get('utm_medium'), referrer, click_id: !!(q.get('gclid') || q.get('msclkid')) };
  if (s) s.setItem(ATTRIBUTION, JSON.stringify(a));
  else memory = { ...(memory || {}), attribution: a };
  return a;
}

const tracking = () => typeof window !== 'undefined' && navigator.doNotTrack !== '1' && window.doNotTrack !== '1';

/** Record one event: page_view, browse, product_view, add_to_cart, checkout_start, purchase. */
export function track(event, { listingId = null, orderRef = null } = {}) {
  if (!tracking()) return;
  try {
    const req = storefront.sfTrack({ session: session(), event, listing_id: listingId, order_ref: orderRef, attribution: attribution() });
    fetch(req.url, { method: req.method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(req.data), keepalive: true, credentials: 'same-origin' }).catch(() => {});
  } catch {
    /* analytics never breaks the page */
  }
}
